var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('generic-button',{attrs:{"variant":_vm.variant,"icon":_vm.withIcon?'external-link-alt':'',"size":_vm.size},on:{"click":function($event){return _vm.$emit('click')},"middleClick":function($event){return _vm.$emit('middleClick')}}})}
var staticRenderFns = []

export { render, staticRenderFns }